module.exports = __webpack_public_path__ + "assets/img/WeChatPay.77795e30.svg";